import { SearchX, ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={ShieldAlert}
      title={t('feedback.forbiddenTitle')}
      action={
        <ButtonLink to="/" variant="secondary">
          {t('actions.backHome')}
        </ButtonLink>
      }
    >
      {t('feedback.forbiddenText')}
    </EmptyState>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={SearchX}
      title={t('feedback.notFoundTitle')}
      action={
        <ButtonLink to="/" variant="secondary">
          {t('actions.backHome')}
        </ButtonLink>
      }
    >
      {t('feedback.notFoundText')}
    </EmptyState>
  );
}
